// Suscripcion a notificaciones push web para las alertas de precio (canal
// instantaneo aditivo al email que ya existe, ver server/services/alertNotifications.js).
// Solo tiene sentido con cuenta -- el backend exige requireUser en /api/push/subscribe.

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

function isPushSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window;
}

async function getExistingSubscription() {
    if (!isPushSupported()) {
        return null;
    }
    const registration = await navigator.serviceWorker.ready;
    return registration.pushManager.getSubscription();
}

async function subscribeToPush() {
    if (!isPushSupported()) {
        throw new Error('Este navegador no soporta notificaciones push.');
    }

    const publicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
    if (!publicKey) {
        throw new Error('Notificaciones push no configuradas.');
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
        throw new Error('Permiso de notificaciones denegado.');
    }

    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
    });

    const response = await fetch('/api/push/subscribe', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(subscription.toJSON())
    });

    if (!response.ok) {
        throw new Error('No se pudo guardar la suscripcion push.');
    }

    return subscription;
}

async function unsubscribeFromPush() {
    const subscription = await getExistingSubscription();
    if (!subscription) {
        return;
    }

    await fetch('/api/push/subscribe', {
        method: 'DELETE',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ endpoint: subscription.endpoint })
    });

    await subscription.unsubscribe();
}

export { isPushSupported, getExistingSubscription, subscribeToPush, unsubscribeFromPush };
